import { EFinancingProgram } from '@if/core/types'
import { Message } from '@mui/icons-material'
import { Card, useTheme } from '@mui/material'
import { IconButtonWithTooltip } from '@src/components'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditApplication } from '../../../data/types'

interface SideBarProps {
  isTopSideBarOpen: boolean
  isSideBarOpen: boolean
  app: CreditApplication
  lockCardHeight: number
  messageCardHeight: number
  financingProgramId?: EFinancingProgram
  showFraudSideBar: boolean
}

const CreditApplicationChatMessageSideBar = ({
  isTopSideBarOpen,
  isSideBarOpen,
  app,
  lockCardHeight,
  messageCardHeight,
  financingProgramId,
  showFraudSideBar,
}: SideBarProps) => {
  const theme = useTheme()
  const borderColor = theme.palette.divider
  const { t } = useTranslation()

  const handleChatMessageClick = () => {
    window.open(`/chat-dashboard/${financingProgramId}/${app?.id}`, '_blank')
  }

  const calculateYOffest = () => {
    let height = 0
    if (isTopSideBarOpen)
      height += lockCardHeight * 0.06185 + 25
    if (isSideBarOpen)
      height += messageCardHeight * 0.06185 + 21
    const base = height > 0 ? height : 23.4
    return showFraudSideBar ? base + 3 : base
  }

  return (
    <Card
      style={{
        position: 'fixed',
        left: 0,
        top: `${calculateYOffest()}em`,
        zIndex: 999,
        padding: 0,
        margin: 0,
        msTransitionDuration: '300ms',
        transitionProperty: 'all',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderRadius: 2,
        borderColor,
      }}
    >
      <IconButtonWithTooltip
        tooltip={t('instantMessage.title')}
        icon={<Message />}
        onClick={handleChatMessageClick}
      />
    </Card>
  )
}

export default memo(CreditApplicationChatMessageSideBar)
